<template>
  <div class="pagination">
    <div class="list">
      <div class="list-item" :class="[i + 1 === cur ? 'sel' : '']" v-for="(v, i) in list" :key="i" @click="handleClick(i)">
        {{i + 1}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      cur: 1
    }
  },
  props: {
    total: {
      type: Number,
      default: 0,
      required: false
    },
    pageSize: {
      type: Number,
      default: 10,
      required: false
    },
    current: {
      type: Number,
      default: 1,
      required: false
    }
  },
  methods: {
    handleClick (i) {
      const page = i + 1
      if (page !== this.cur) {
        this.cur = i + 1
        this.$emit('change', i + 1)
      }
    }
  },
  created () {
    const arr = []
    if (this.total) {
      arr.length = Math.ceil(this.total / this.pageSize)
      this.list = arr
    }
  }
}
</script>

<style scoped lang="scss">
.pagination {
  .list {
    display: flex;
    .list-item {
      width: 30px;
      height: 30px;
      border: 1px solid #999;
      // text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;
      margin: 0px 8px;
      &.sel {
        border-color: #5ee0d8db;
      }
    }
  }
}
</style>
